import { Component, Input, NO_ERRORS_SCHEMA } from '@angular/core';
import { IAccordionItem } from '../../models';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-accordion',
  templateUrl: './accordion.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgbAccordionModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AccordionComponent {
  @Input() items: IAccordionItem[] = [];
}
